export default __webpack_public_path__ + "static/media/warning--skewed-t-roads-left--g2.57907e78.png";